import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    class: _normalizeClass([[_ctx.widgetClasses, `bg-${_ctx.color}`], "card hoverable"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("i", {
        class: _normalizeClass(`${_ctx.svgIcon} ${_ctx.iconColor} fs-3x`)
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass([`text-inverse-${_ctx.color}`, "fw-bolder fs-1 mb-2 mt-5"])
      }, _toDisplayString(_ctx.title), 3),
      _createElementVNode("div", {
        class: _normalizeClass([`text-inverse-${_ctx.color}`, "fw-bold fs-6"])
      }, _toDisplayString(_ctx.description), 3)
    ])
  ], 2))
}